<template xmlns="http://www.w3.org/1999/html">
  <div>
    <v-row no-gutters v-if="!isIos && $vuetify.breakpoint.smAndDown && showDownloadAPK" class="download-bar">
      <v-icon @click="hideDownloadBar()" class="mr-2" aria-label="Close">mdi-close</v-icon>
      <img class="mr-2" width="30" height="30" src="/static/svg/Nagad_Square_icon.svg" alt="download" />
      <v-col class="mr-1">
        <label>{{ $t(`label.downloadApp`) }}</label>
      </v-col>
      <app-button title="DOWNLOAD" :action="downloadAPK" :customClass="`download-bar-button subtitle-1`"></app-button>
    </v-row>
    <v-toolbar
      flat
      :height="$vuetify.breakpoint.mdAndUp ? 72 : 60"
      :class="`full-width header-top ng-header ${!isIos && $vuetify.breakpoint.smAndDown && showDownloadAPK ? 'download-bar-height' : ''}`"
    >
      <!-- Mobile: same three slots on every page: menu · logo · balance -->
      <div v-if="$vuetify.breakpoint.smAndDown" class="ng-header-mobile">
        <button type="button" class="ng-header-icon-btn" aria-label="Menu" @click.stop="drawer = !drawer">
          <v-icon color="white">mdi-menu</v-icon>
        </button>

        <router-link :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }" class="ng-header-logo">
          <img height="28" src="static/svg/logo.png" alt="nagad88 logo" />
        </router-link>

        <div class="ng-header-actions">
          <template v-if="isLoggedIn">
            <router-link :to="{ name: routeName.INBOX, params: { lang: this.$route.params.lang } }" class="ng-header-icon-btn" :aria-label="$t(`label.inbox`)">
              <v-badge dot offset-x="4" offset-y="4" :color="hasUnreadInboxMsg ? 'red' : 'transparent'">
                <img src="/static/svg/Inboxwhite.png" width="26" height="26" alt="" />
              </v-badge>
            </router-link>
            <div class="ng-balance-chip">
              <button type="button" class="ng-balance-amount" :aria-label="$t(`label.mainWallet`)" @click="getMemberWallet()">
                <template v-if="notLoading">
                  <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
                  <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
                </template>
                <v-progress-circular v-else indeterminate color="amber" :width="2" :size="16"></v-progress-circular>
              </button>
              <button type="button" class="ng-balance-plus" :aria-label="$t(`label.deposit`)" @click="goToDepositPage()">
                <v-icon size="18" color="#121734">mdi-plus</v-icon>
              </button>
            </div>
          </template>
          <button v-else type="button" class="ng-btn-cta ng-header-login" @click="openLoginDialog()">{{ $t(`label.login`) }}</button>
        </div>
      </div>

      <!-- Desktop: logo · game nav · wallet · account, all on one row -->
      <div v-if="$vuetify.breakpoint.mdAndUp" class="ng-header-desktop">
        <router-link :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }" class="ng-header-logo">
          <img height="32" src="static/svg/logo.png" alt="nagad88 logo" />
        </router-link>

        <app-page-navigator inline :openLoginDialog="openLoginDialog"></app-page-navigator>

        <div class="ng-header-actions">
          <template v-if="isLoggedIn">
            <button type="button" class="ng-header-icon-btn" :aria-label="$t(`label.inbox`)" @click="goToInboxPage">
              <v-badge dot offset-x="4" offset-y="4" :color="hasUnreadInboxMsg ? 'red' : 'transparent'">
                <img src="/static/svg/Inboxwhite.png" width="26" height="26" alt="" />
              </v-badge>
            </button>
            <div class="ng-wallet-box">
              <div class="ng-wallet-text">
                <span class="ng-wallet-label">{{ $t(`label.mainWallet`) }}</span>
                <span class="ng-wallet-amount" v-if="notLoading">
                  <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
                  <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
                </span>
                <v-progress-circular v-else indeterminate color="amber" :width="2" :size="16"></v-progress-circular>
              </div>
              <v-icon size="20" color="white" @click="getMemberWallet()" class="refresh-balance">mdi-refresh</v-icon>
              <button type="button" class="ng-btn-cta" @click="goToDepositPage()">{{ $t('label.deposit') }}</button>
            </div>
            <v-menu offset-y left nudge-bottom="8" min-width="200">
              <template v-slot:activator="{ on, attrs }">
                <button type="button" class="ng-account-btn" :aria-label="$t(`label.profile`)" v-bind="attrs" v-on="on">
                  <img width="28" height="28" src="/static/svg/mobileBottomNavigation/toolbar-profile.png" alt="" />
                  <v-icon size="18" color="white">mdi-chevron-down</v-icon>
                </button>
              </template>
              <v-list dense class="ng-account-menu">
                <v-list-item @click="goToProfilePage">
                  <v-list-item-title>{{ $t(`label.profile`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="goToWithdrawalPage">
                  <v-list-item-title>{{ $t(`label.withdrawal`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: routeName.VIPTIER, params: { lang: this.$route.params.lang } }">
                  <v-list-item-title>{{ $t(`label.viptier`) }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openLanguageDialog()">
                  <v-list-item-title>{{ $t(`label.language`) }} · {{ $t(`language.${currentLanguage}`) }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout">
                  <v-list-item-title>{{ $t(`label.logout`) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-else>
            <app-login-embedded :openRegisterDialog="this.openRegisterDialog" :openLoginDialog="this.openLoginDialog" :openLanguageDialog="this.openLanguageDialog"></app-login-embedded>
            <button type="button" class="ng-header-icon-btn" :aria-label="$t(`label.language`)" @click="openLanguageDialog()">
              <v-avatar size="24" class="language-button">
                <img width="24" height="24" :src="`/static/image/country/${currentCurrency}.svg`" alt="" />
              </v-avatar>
            </button>
          </template>
        </div>
      </div>
    </v-toolbar>

    <v-navigation-drawer v-if="$vuetify.breakpoint.smAndDown" class="side-navigation-drawer ng-drawer" v-model="drawer" fixed left temporary width="310px">
      <v-list nav class="mobile_list_menu">
        <v-list-item-group active-class="">
          <v-list-item class="side-nav-logo">
            <!--            :style="{ transform: imageRotation }"-->
            <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer" height="14" width="24"></v-app-bar-nav-icon>
            <img style="margin-left: auto" width="75" height="25" src="static/svg/logo.png" alt="nagad88 logo" />
            <img style="margin-left: auto; transform: rotate(0deg); transition: transform 0.3s;" src="/static/svg/right-arrows_w.png" @click.stop="rotateImage" height="20" width="20" />
          </v-list-item>
          <v-list-item :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper">
                <img src="../../assets/svg/side nav/refer.png" height="42" width="42" alt="nagad88 referral" class="side-menu-icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="auto" class="mt-1 breakWord-onspace">{{ $t(`label.referral`) }}</v-col>
                    <div class="text-center" style="margin-left: 2px; background-color: #04b22b; border-radius: 8px; color: white; font-size: 10px;width:30px">
                      <span class="font-weight-bold">{{ $t(`label.best`) }}</span>
                    </div>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-icon class="ng-drawer-chevron">mdi-chevron-right</v-icon>
            </v-row>
          </v-list-item>

          <v-list-item :to="{ name: routeName.APPLY_AGENT, params: { lang: this.$route.params.lang } }">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper">
                <img src="../../assets/svg/side nav/Affiliate.png" height="42" width="42" alt="nagad88 referral" class="side-menu-icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">
                  <v-row no-gutters justify="start" align="center">
                    <v-col cols="auto" class="mt-1 breakWord-onspace">{{ $t(`label.affiliate`) }}</v-col>
                    <!--                    <div class="text-center" style="margin-left: 2px; background-color: #04b22b; border-radius: 8px; color: white; font-size: 10px;width:30px">-->
                    <!--                      <span class="font-weight-bold">{{ $t(`label.new`) }}</span>-->
                    <!--                    </div>-->
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-icon class="ng-drawer-chevron">mdi-chevron-right</v-icon>
            </v-row>
          </v-list-item>
          <v-list-item :to="{ name: routeName.PROMOTION, params: { lang: this.$route.params.lang } }" class="list-item-standalone">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper">
                <img src="../../assets/svg/side nav/promotion.png" height="41" width="41" alt="nagad88 promotion" class="side-menu-icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">{{ $t(`label.promotion`) }}</v-list-item-title>
              </v-list-item-content>

              <!--                  <v-btn>-->
              <v-icon class="ng-drawer-chevron">mdi-chevron-right</v-icon>
              <!--                  </v-btn>-->
            </v-row>
          </v-list-item>
          <v-list-item :to="{ name: routeName.VIPTIER, params: { lang: this.$route.params.lang } }">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper">
                <img src="/static/svg/mobileMenu/viptier.png" height="42" width="42" alt="nagad88 referral" class="side-menu-icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">{{ $t(`label.viptier`) }}</v-list-item-title>
              </v-list-item-content>
              <v-icon class="ng-drawer-chevron">mdi-chevron-right</v-icon>
            </v-row>
          </v-list-item>
          <!--          <v-list-item :to="{ name: routeName.VIP, params: { lang: this.$route.params.lang } }">-->
          <!--            <v-row no-gutters class="list-item-container">-->
          <!--              <v-list-item-icon>-->
          <!--                <img src="../../assets/svg/side nav/Nagad88 Ladderboard.png" height="42" width="42" class="side-menu-icon" />-->
          <!--              </v-list-item-icon>-->
          <!--              <v-list-item-content>-->
          <!--                <v-list-item-title style="padding-left: 7px">-->
          <!--                  <v-row no-gutters justify="start" align="center">-->
          <!--                    <v-col cols="auto" class="mt-1 breakWord-onspace">{{ $t(`label.bettingPassNavName`) }}</v-col>-->
          <!--                    &lt;!&ndash;                    <div class="text-center" style="margin-left: 2px; background-color: #04b22b; border-radius: 8px; color: white; font-size: 10px;width:30px">&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      <span class="font-weight-bold">{{ $t(`label.new`) }}</span>&ndash;&gt;-->
          <!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                  </v-row>-->
          <!--                </v-list-item-title>-->
          <!--              </v-list-item-content>-->
          <!--              <v-icon class="ng-drawer-chevron">mdi-chevron-right</v-icon>-->
          <!--            </v-row>-->
          <!--          </v-list-item>-->

          <hr />

          <div class="box">
            <!--            <item>-->
            <v-list-item class="sidenav icon" style="width: 200px" :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }" exact>
              <v-col>
                <v-row class="align-content-center" style="display: block; text-align-last: center">
                  <v-list-item-icon>
                    <img src="/static/svg/mobileMenu/Home.svg" height="30px" width="30px" alt="nagad88 cricket" class="side-menu-icon" />
                  </v-list-item-icon>
                </v-row>
                <v-row>
                  <v-list-item-content class="text-center">
                    <v-list-item-title style="font-size: 14px">{{ $t(`label.home`) }}</v-list-item-title>
                  </v-list-item-content>
                </v-row>
              </v-col>
            </v-list-item>

            <!--            </item>-->
            <!--            <item>-->
            <!--              <v-list-item class="sidenav icon" style="width: 200px"> &lt;!&ndash;hotgame&ndash;&gt;-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block; text-align-last: center">-->
            <!--                    <v-list-item-icon class="align-center">-->
            <!--                      <img src="/static/svg/mobileMenu/Hot.svg" height="32px" width="30px"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center"  style="display: table">-->
            <!--                      <v-list-item-title style="font-size: 14px">{{ $t(`label.hotGames`) }}</v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->

            <v-list-item class="sidenav icon " style="width: 200px" v-for="gameType in storageGameProviderType" :key="gameType.type" :to="getListItemTo(gameType)" exact>
              <v-row class="align-content-center" style="display: block">
                <v-list-item-icon class="side-menu-icon-wrapper">
                  <img :src="`/static/svg/mobileMenu/${gameType.type}.svg`" class="side-menu-icon" :alt="`${gameType.type}`" />
                </v-list-item-icon>
                <v-list-item-content class="text-center">
                  <v-list-item-title style="font-size: 14px">{{ $t(`label.${gameType.type}`) }}</v-list-item-title>
                </v-list-item-content>
              </v-row>
            </v-list-item>

            <!--<<<<<<< Updated upstream-->
            <!--=======-->
            <!--            </item>-->
            <!--&lt;!&ndash;            3rd row&ndash;&gt;-->
            <!--            <item>-->
            <!--              <v-list-item :to="{ name: routeName.TABLE_GAMES }">-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block"-->
            <!--                    <v-list-item-icon>-->
            <!--                      <img src="../../assets/svg/side nav/casino.png" height="42" width="42"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center">-->
            <!--                      <v-list-item-title style="font-size: 14px"> {{ $t(`label.table`) }} </v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->
            <!--            <item>-->
            <!--              <v-list-item> &lt;!&ndash;Crash&ndash;&gt;-->
            <!--                <v-col>-->
            <!--                  <v-row class="align-content-center" style="display: block">-->
            <!--                    <v-list-item-icon>-->
            <!--                      <img src="../../assets/svg/side nav/plane.png" height="42" width="42"/>-->
            <!--                    </v-list-item-icon>-->
            <!--                  </v-row>-->
            <!--                  <v-row>-->
            <!--                    <v-list-item-content class="text-center">-->
            <!--                      <v-list-item-title style="font-size: 14px"> {{ $t(`label.crash`) }} </v-list-item-title>-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-row>-->
            <!--                </v-col>-->
            <!--              </v-list-item>-->
            <!--            </item>-->
            <!--            <item> </item>-->
            <!--       for language    <v-list-item-content :class="['pl-1', isLoggedIn ? 'pt-0' : '']">-->
            <!--&gt;>>>>>> Stashed changes-->
          </div>
          <br />
          <hr />

          <v-list-item @click="openLanguageDialog()">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img src="../../assets/svg/side nav/language.png" alt="nagad88 cricket exchange" class="side-menu-bottom" style="padding-left: 2px; width: 34px" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">{{ $t(`label.language`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
          <v-list-item href="javascript:void(0);" @click="showIntercomLC">
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img src="/static/svg/customer-service.png" class="side-menu-bottom" style="width: 35px !important;" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">{{ $t(`label.liveChat`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>

          <v-list-item @click="downloadAPK" v-if="isDAndroid && showDownload">
            <v-row no-gutters class="list-item-container" style="padding-left: 26px">
              <v-list-item-icon class="side-menu-icon-wrapper">
                <img src="/static/svg/mobileMenu/apkDownload.png" alt="nagad88 apk" class="side-menu-bottom" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 12px">{{ $t(`label.download`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>

          <v-list-item @click="logout" v-if="isLoggedIn">
            <!-- Same structure as the rows above so icon and label line up -->
            <v-row no-gutters class="list-item-container">
              <v-list-item-icon class="side-menu-icon-wrapper" style="margin: 3px">
                <img src="/static/svg/logout.png" alt="" class="side-menu-bottom" style="width: 35px !important; height: 35px; object-fit: contain;" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="padding-left: 7px">{{ $t(`label.logout`) }}</v-list-item-title>
              </v-list-item-content>
            </v-row>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div :class="`body ${!isIos && $vuetify.breakpoint.smAndDown && showDownloadAPK ? 'download-bar-height-body' : ''}`">
      <router-view></router-view>
      <app-footer></app-footer>
    </div>

    <div v-if="$vuetify.breakpoint.smAndDown" class="bottom-navigator">
      <v-row no-gutters v-if="!isLoggedIn" class="bottom-navigator-before-login">
        <v-col cols="4" @click="openLanguageDialog()" class="bottom-navigator-before-login-first d-flex flex-row justify-center align-center no-gutters">
          <div class="d-flex flex-column justify-center align-center">
            <v-btn icon small>
              <v-avatar size="25" class="language-button">
                <img width="25" height="25" :src="`/static/image/country/${currentCurrency}.svg`" alt="nagad88 cricket exchange" />
              </v-avatar>
            </v-btn>
          </div>
          <div no-gutters class="d-flex flex-column justify-center align-center">
            <span style="font-weight: bolder; font-size: 12px; padding-left: 10px;">{{ languageList[0].currencyCd }} {{ languageList[0].currency }}</span>
            <span style=" font-weight: bolder; font-size: 12px; padding-left: 10px;">
              {{ $t(`language.${currentLanguage}`) }}
            </span>
            <!--            <span v-for="l in language" :key="l.id" style="font-size: 12px">{{ l.title }}</span>-->
          </div>
        </v-col>
        <v-col cols="4" @click="openLoginDialog()" class="bottom-navigator-before-login-third d-flex justify-center align-center no-gutters">
          <b>{{ $t(`label.login`) }}</b>
        </v-col>
        <v-col cols="4" @click="this.openRegister" class="bottom-navigator-before-login-second d-flex justify-center align-center no-gutters">
          <b>{{ $t(`label.register`) }}</b>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="isLoggedIn">
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" exact exact-active-class="link-active" :to="{ name: routeName.HOME, params: { lang: this.$route.params.lang } }">
            <div class="text-center">
              <img class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-home.png`" alt="home" />
              <p class="bottom-navigator-text">{{ $t(`label.home`) }}</p>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" exact exact-active-class="link-active" :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }">
            <div class="text-center">
              <img class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-referral.png`" alt="referral" />
              <p class="bottom-navigator-text">{{ $t(`label.referral`) }}</p>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-row class="cols" style="justify-content:center">
            <router-link
              class="bottom-navigation-center-button "
              :to="{ name: routeName.FUNDS, params: { lang: this.$route.params.lang } }"
              style="line-height: .7; align-items: center;
                         justify-content: center;
                         display: flex; padding-left: 8px !important;"
            >
              <div class="text-center">
                <img class="icon_btm_nav" style="height: 30px;width: 30px;" :src="`/static/svg/mobileBottomNavigation/toolbar-newdepositicon.png`" alt="deposit" />
              </div>

              <!--            <img class="icon_btm_nav depo_icon_btm_nav"-->
              <!--                 :src="`/static/svg/mobileBottomNavigation/toolbar-newdepositicon.png`" alt="deposit"/>-->
              <!--            <p>{{ $t(`label.deposit`) }}</p>-->
              <!--            <div>{{ $t(`label.deposit`) }}</div>-->
            </router-link>
          </v-row>
          <v-row
            class="white--text cols"
            style=" align-items: center;
                         justify-content: center;
                         display: flex; height: 45%;"
          >
            <span class="bottom-navigator-text middledeposit">{{ $t(`label.deposit`) }}</span>
          </v-row>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" exact exact-active-class="link-active" :to="{ name: routeName.PROMOTION, params: { lang: this.$route.params.lang } }">
            <div class="text-center">
              <img class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-promotion.png`" alt="promotion" />
              <p class="bottom-navigator-text">{{ $t(`label.promotion`) }}</p>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="2.4" class="grow">
          <v-btn depressed height="auto" tile :ripple="false" to="#" @click="openProfileSheet">
            <div class="text-center">
              <img class="icon_btm_nav" :src="`/static/svg/mobileBottomNavigation/toolbar-profile.png`" alt="nagad88 crazytime exchange" />
              <p class="bottom-navigator-text">{{ $t(`label.profile`) }}</p>
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <profile-sheet :showProfileSheet="showProfileSheet" :closeProfileSheet="closeProfileSheet" :logout="logout"></profile-sheet>

    <app-floating-reward></app-floating-reward>
    <app-floating-contactUs></app-floating-contactUs>

    <!-- WAIT REGISTER DIALOG -->
    <app-dialog :dialogShow="waitRegisterDialogShow" :max-width="600" :title="$t(`label.wait`)" :closeAction="closeWaitRegisterDialog">
      <app-wait-register :openRegisterDialog="openRegisterDialog" :openLoginDialog="openLoginDialog"></app-wait-register>
    </app-dialog>

    <!-- REGISTER DIALOG -->
    <!--    <app-dialog :dialogShow="registerDialogShow" :max-width="400" :min-height="724" :title="$t(`label.signUp`)"-->
    <!--                :isAuth="false" :header_title="'register'" :openLoginDialog="openLoginDialog"-->
    <!--                :closeAction="this.closeRegisterDialog">-->
    <!--      <app-register :openLoginDialog="this.openLoginDialog" :registerErrorMsg="this.registerErrorMsg"></app-register>-->
    <!--    </app-dialog>-->

    <app-dialog
      :dialogShow="registerDialogShow"
      :max-width="400"
      :min-height="724"
      :title="$t(`label.joininregister`)"
      :isAuth="false"
      :header_title="'register'"
      :openLoginDialog="openLoginDialog"
      :closeAction="this.closeRegisterDialog"
    >
      <app-register :openLoginDialog="this.openLoginDialog" :registerErrorMsg="this.registerErrorMsg"></app-register>
    </app-dialog>
    <!-- FORGOT PASSWORD DIALOG -->
    <app-dialog :dialogShow="forgotPasswordDialogShow" :max-width="400" :title="$t(`label.forgotPassword`).slice(0, -1)" :closeAction="this.closeForgotPasswordDialog" :customClass="'pa-0'">
      <app-forgot-password :openRegisterDialog="openRegisterDialog" :openLoginDialog="this.openLoginDialog"></app-forgot-password>
    </app-dialog>

    <!-- RESET PASSWORD DIALOG -->
    <app-dialog :dialogShow="resetPasswordDialogShow" :max-width="400" :title="$t(`label.resetPassword`)" :closeAction="this.closeResetPasswordDialog">
      <app-reset-password :resetPasswordMemberCode="resetPasswordObj.memberCode" :resetPasswordContact="resetPasswordObj.contact"></app-reset-password>
    </app-dialog>

    <!-- LOGIN DIALOG -->
    <app-dialog
      :dialogShow="loginDialogShow"
      ref="loginDialog"
      :max-width="400"
      :title="$t(`label.welcomeToBrand`)"
      :isAuth="false"
      :header_title="'login'"
      :openRegisterDialog="openRegisterDialog"
      :closeAction="this.closeLoginDialog"
      :customClass="'pa-0'"
    >
      <app-login
        :openRegisterDialog="this.openRegisterDialog"
        :loginErrorMsg="this.loginErrorMsg"
        :openForgotPasswordDialog="this.openForgotPasswordDialog"
        :closeAction="this.closeLoginDialog"
      ></app-login>
    </app-dialog>

    <!-- NEW REGISTER DIALOG -->
    <app-dialog :dialogShow="newRegisterDialogShow" ref="newRegisterDialog" :max-width="400" :title="$t(`label.newRegisterSuccess`)" :closeAction="this.closeNewRegisterDialogShow">
      <app-new-register :closeNewRegisterDialog="closeNewRegisterDialogShow"></app-new-register>
    </app-dialog>

    <!-- REGISTER SUCCESS DIALOG -->
    <app-dialog
      :dialogShow="registerSuccessDialogShow"
      :isRegSuccess="true"
      ref="registerSuccessDialog"
      :max-width="400"
      :title="$t(`label.registerSuccess`)"
      :closeAction="this.closeRegisterSuccessDialog"
    >
      <app-register-success :closeRegisterSuccessDialog="closeRegisterSuccessDialog"></app-register-success>
    </app-dialog>

    <!--PT Quick Transfer Dialog-->
    <app-dialog :dialogShow="quickTransferDialogShow" :max-width="450" :title="this.transferMessage" :closeAction="this.closeQuickTransferDialog">
      <app-transfer-component :isNonBanking="true" :provider="this.transferToProvider" :ptGameInfo="this.ptGameInfo"></app-transfer-component>
    </app-dialog>

    <!-- PAGE DIALOG -->
    <app-dialog :dialogShow="pageDialogShow" :max-width="400" :title="pageDialog.title" :closeAction="this.pageDialog.dialogXButton">
      <app-page-dialog
        :dialogMessageTitle="pageDialog.messageTitle"
        :dialogMessage="pageDialog.message"
        :dialogButton="pageDialog.button"
        :dialog-attachments="pageDialog.attachment"
      ></app-page-dialog>
    </app-dialog>

    <!-- INSTANT POPUP DIALOG -->
    <instant-popup-dialog :dialog-show="instantDialogShow" :max-width="438" :closeAction="this.closeInstantPopup" :array-info="popupAnnouncement"></instant-popup-dialog>

    <instant-login-popup-dialog :dialog-show="instantLoginDialogShow" :max-width="438" :closeAction="this.closeInstantLoginPopup" :array-info="loginPopupAnnouncement"></instant-login-popup-dialog>

    <free-spin-games-dialog
      :dialog-show="freeSpinDialogShow"
      :games="freeSpinGames"
      :spin-count="freeSpinCount"
      @close="dismissFreespinDialog"
    ></free-spin-games-dialog>

    <ios-add-to-home-dialog :dialog-show="iosShortcutDialogShow" :in-app-browser="iosInAppBrowser" :close-action="closeIosShortcutDialog"></ios-add-to-home-dialog>

    <!-- LANGUAGE DIALOG -->
    <app-dialog
      :dialogShow="languageDialogShow"
      ref="languageDialog"
      :max-width="300"
      :title="$t(`label.currencyLanguage`)"
      :isAuth="false"
      :header_title="'login'"
      :closeAction="this.closeLanguageDialog"
      :customClass="'pa-0'"
    >
      <app-language :closeAction="this.closeLanguageDialog"></app-language>
    </app-dialog>
    <!--    <app-dialog :dialogShow="languageDialogShow" ref="languageDialog" :max-width="450" :title="'Currency and Language'"-->
    <!--                :isAuth="false" :header_title="'login'" :closeAction="this.closeLanguageDialog">-->
    <!--      <app-language :closeAction="this.closeLanguageDialog"></app-language>-->
    <!--    </app-dialog>-->

    <!--    <app-loading-progress ref="loading"></app-loading-progress>-->
    <app-loading-progress ref="loading"></app-loading-progress>
  </div>
</template>

<script>
import '@mdi/font/css/materialdesignicons.css'
import moment from 'moment'
import { GRAB_COIN_SETTING } from '@/store/bonus.module'
import AccountLiveChat from '@/assets/svg/liveChat.svg'
import AppTransferComponent from '@/views/bank/transfer'
import AccountProfile from '@/assets/svg/account-profile.svg'
import AccountWallet from '@/assets/svg/account-deposit.svg'
import AccountWithdrawal from '@/assets/svg/account-withdrawal.svg'
import AccountHistory from '@/assets/svg/account-history.svg'
import AppFloatingReward from '@/components/home/FloatingReward.vue'
import AppFloatingContactUs from '@/components/home/FloatingContactUs.vue'
import NavTransfer from '@/assets/svg/transfer.svg'
import NavDeposit from '@/assets/svg/deposit.svg'
import NavWithdrawal from '@/assets/svg/withdrawal.svg'
import NavLogout from '@/assets/svg/logout.svg'
import vipIcon from '@/assets/svg/vip.svg'
import InstantPopupDialog from '@/components/InstantPopupDialog.vue'
import InstantLoginPopupDialog from '@/components/InstantLoginPopupDialog.vue'
import FreeSpinGamesDialog from '@/components/FreeSpinGamesDialog.vue'
import { bonusService } from '@/services'
import IosAddToHomeDialog from '@/components/layout/IosAddToHomeDialog.vue'

import { AnnouncementType, DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
// import AppRegisterFromAF from '@/views/defaultregister.vue'
import AppRegister from '@/views/register.vue'
import AppRegisterSuccess from '@/components/member/registerSuccess.vue'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import AppWaitRegister from '@/components/member/waitRegister.vue'
import AppForgotPassword from '@/components/member/forgotPassword.vue'
import AppResetPassword from '@/components/member/resetPassword.vue'
import AppPageDialog from '@/components/layout/PageDialog.vue'
import AppPageNavigator from '@/components/layout/PageNavigator.vue'
import AppFooter from '@/components/layout/Footer.vue'
import AppLoadingProgress from '@/components/layout/LoadingProgress.vue'
import AppLogin from '@/components/member/login.vue'
import AppLanguage from '@/components/layout/Language.vue'
import AppNewRegister from '@/components/member/newRegister.vue'
import { SESSION, SHARED, CACHE_KEY } from '@/constants/constants'
import { locale, errorCodeHelper, uiHelper } from '@/util'
import {
  MEMBER_RESET_LOGOUT_STORE,
  MEMBER_RESET_LOGIN_STORE,
  MEMBER_LOGOUT,
  MEMBER_REFRESH_TOKEN,
  MEMBER_RESET__STORE,
  MEMBER_CHECK_TOKEN_VALIDITY,
  MEMBER_WALLET,
  MEMBER_RESET_FORGOT_PASSWORD_STORE,
  MEMBER_RESET_RESET_PASSWORD_STORE,
  MEMBER_CONTACT_VERIFICATION,
  MEMBER_RESET_CONTACT_VERIFICATION_STORE,
  MEMBER_RESET_REGISTER_STORE,
  MEMBER_GET_VIP_PROGRESS,
  MEMBER_RESET_SMS_VERIFICATION,
  ONE_SIGNAL_PLAYER_IDS,
  ONE_SIGNAL_PLAYER_IDS_RESET_STORE,
  MEMBER_RESET_UPDATE_FORGOT_PASSWORD,
  MEMBER_VIP_TIER_PROGRESS
} from '@/store/member.module'
import { LOGIN_POPUP_LIST, POPUP_LIST } from '@/store/announcement.module'
import { WHEEL_MODULE } from '@/store/wheel.module'
import { INBOX_GET_MSG } from '@/store/inbox.module'
import OneSignalVue from 'onesignal-vue'
import { TELEGRAM_CONFIG } from '@/store/sso-auth.module'
import { GET_FACEBOOK_PIXEL } from '@/store/facebookpixel.module'
import { captureAdClick, initChannelPixel, sendChannelPageview } from '@/util/ad-click-helper'

export default {
  name: 'layoutMaster',
  components: {
    // AppRegisterFromAF,
    AccountLiveChat,
    AppTransferComponent,
    AccountProfile,
    AccountWallet,
    AccountWithdrawal,
    AccountHistory,
    AppLogin,
    AppLanguage,
    AppRegister,
    AppRegisterSuccess,
    AppNewRegister,
    AppLoginEmbedded,
    AppForgotPassword,
    AppResetPassword,
    AppPageDialog,
    AppPageNavigator,
    AppFooter,
    AppLoadingProgress,
    AppWaitRegister,
    AppFloatingReward,
    AppFloatingContactUs,
    NavDeposit,
    NavWithdrawal,
    NavLogout,
    NavTransfer,
    vipIcon,
    InstantPopupDialog,
    InstantLoginPopupDialog,
    FreeSpinGamesDialog,
    IosAddToHomeDialog
  },
  data: () => ({
    showBalance: true,
    regionLocale: uiHelper.getRegionLocale(),
    imageRotation: 'rotate(0deg)',
    selectedGameType: null,
    googleURL: 'www.google.com',
    playerIds: '',
    showDownloadAPK: true,
    isIos: uiHelper.IsIos(),
    isDAndroid: uiHelper.isAndroid(),
    showProfileSheet: false,
    time: '',
    instantDialogShow: false,
    instantLoginDialogShow: false,
    freeSpinDialogShow: false,
    freeSpinGames: [],
    freeSpinCount: 0,
    freeSpinChecking: false,
    freeSpinDismissed: false,
    freeSpinDismissStorageKey: '',
    iosShortcutDialogShow: false,
    iosInAppBrowser: uiHelper.isIosInAppBrowser(),
    iosShortcutTimer: null,
    instantPopupAnnouncement: [],
    drawer: false,
    notLoading: true,
    currentLanguage: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    transferMessage: locale.getMessage(`label.ptQuickTransfer`, ['PT']),
    isTransferWalletLoginDialog: false,
    ptGameInfo: null,
    transferToProvider: 'PT',
    devicePlatform: DevicePlatform,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    uihelper: uiHelper,
    quickTransferDialogShow: false,
    registerSuccessDialogShow: false,
    newRegisterDialogShow: false,
    waitRegisterDialogShow: false,
    registerDialogShow: false,
    loginDialogShow: false,
    forgotPasswordDialogShow: false,
    resetPasswordDialogShow: false,
    languageDialogShow: false,
    firstTimeRegister: true,
    routeName: ROUTE_NAME,
    resetPasswordObj: {
      contact: '',
      memberCode: ''
    },
    pageDialogShow: false,
    pageDialog: {
      title: '',
      closePageDialog: () => {},
      messageTitle: '',
      message: [],
      button: []
    },
    memberLink: SHARED.MEMBER_HEADER_NAVIGATOR_LINK,
    loginErrorMsg: '',
    registerErrorMsg: '',
    language: [
      {
        title: 'English',
        cd: 'en'
      },
      {
        title: 'Bengali',
        cd: 'bd'
      }
    ],
    languageList: [
      {
        currency: 'BDT',
        currencyCd: '৳',
        img: 'BDT',
        language: [
          {
            title: 'English',
            cd: 'en'
          },
          {
            title: 'Bengali',
            cd: 'bd'
          }
        ]
      }
    ]
  }),
  computed: {
    facebookPixels() {
      return this.$store.state.facebookPixel.facebookPixels
    },
    toDeposit() {
      if (!this.$route.params.lang) {
        return '/bank/funds'
      } else {
        return `/${this.$route.params.lang}/bank/funds`
      }
    },
    listItemToHOME() {
      if (!this.$route.params.lang) {
        return '/'
      } else {
        return `/${this.$route.params.lang}`
      }
    },

    uiHelper() {
      return uiHelper
    },
    loginPopupAnnouncement() {
      let p = []
      let k = this.$store.state.announcement.popupLoginAnnouncement
      k.forEach(announcement => {
        p.push({
          id: announcement.id,
          date: announcement.announcementDate,
          title:
            announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
              : announcement.titleLocale.find(x => x.language == 'en') != null
              ? announcement.titleLocale.find(x => x.language == 'en').title
              : announcement.titleLocale[0].title,
          message:
            announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
              : announcement.messageLocale.find(x => x.language == 'en') != null
              ? announcement.messageLocale.find(x => x.language == 'en').message
              : announcement.messageLocale[0].message
        })
      })
      if (p.length > 0) {
        this.openInstantLoginPopup()
      }
      return p
    },
    popupAnnouncement() {
      let p = []
      let k = this.$store.state.announcement.popupAnnouncement
      k.forEach(announcement => {
        p.push({
          id: announcement.id,
          date: announcement.announcementDate,
          title:
            announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
              : announcement.titleLocale.find(x => x.language == 'en') != null
              ? announcement.titleLocale.find(x => x.language == 'en').title
              : announcement.titleLocale[0].title,
          message:
            announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
              : announcement.messageLocale.find(x => x.language == 'en') != null
              ? announcement.messageLocale.find(x => x.language == 'en').message
              : announcement.messageLocale[0].message
        })
      })
      if (p.length > 0) {
        this.openInstantPopup()
      }
      return p
    },
    hasUnreadInboxMsg() {
      return this.$store.state.inbox.inboxMsg.filter(m => !m.has_read).length > 0
    },
    grabCoin() {
      let d = this.$store.state.bonus.grabCoinSettings
      return d
    },
    wof() {
      return this.$store.state.wheel.wheel
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    showDownload() {
      return uiHelper.shouldShowDownload(this.$store.state.siteSettings.hideDownloadBar)
    },
    loginResponseComplete() {
      return this.$store.state.member.loginResponse.complete
    },
    verifyContactResponseComplete() {
      return this.$store.state.member.verifyContactResponse.complete
    },
    changeForgotPasswordResponse() {
      return this.$store.state.member.changeForgotPassword.complete
    },
    resetPasswordResponseComplete() {
      return this.$store.state.member.resetPasswordResponse.complete
    },
    registerResponseComplete() {
      return this.$store.state.member.registerResponse.complete
    },
    forgotPasswordResponseComplete() {
      return this.$store.state.member.forgotPasswordResponse.complete
    },
    logoutResponseComplete() {
      return this.$store.state.member.logoutResponse.complete
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    vipLevel() {
      if (uiHelper.getCookie(SESSION.VIP) == null) {
        let m = this.$store.state.member.info
        let vip = m.group
        uiHelper.setCookie(SESSION.VIP, vip, 1)
        return vip
      }
      return uiHelper.getCookie(SESSION.VIP)
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    },
    vipDepositProgress() {
      return (this.vipProgress.current_deposit_progress / this.vipProgress.required_deposit_amount) * 100
    },
    vipRolloverProgress() {
      return (this.vipProgress.current_rollover_progress / this.vipProgress.required_account_rollover) * 100
    },
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    },
    languageSelected() {
      for (const lang of this.languageList) {
        if (lang.currency == this.currentCurrency) {
          // const language = lang.find(l => {
          //     // console.log('language', language);
          //     console.log('l', l);
          // });
          return `${lang.currencyCd} ${lang.currency}`
        }
      }
      return null
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    }
  },
  watch: {
    '$store.state.siteSettings.hideDownloadBar'() {
      this.initShowDownloadAPK()
    },
    facebookPixels: {
      handler(newVal) {
        if (newVal.complete && newVal.success && newVal.data) {
          this.initFacebookPixels(newVal.data)
        }
      },
      immediate: true,
      deep: true
    },
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.getInboxMsg()
        this.getMemberVipTierProgress()
        this.prepareLoginPopups()
      } else {
        this.clearFreespinDismissed()
        this.freeSpinDialogShow = false
      }
    },
    ProviderTypes() {
      this.storageGameProviderType = this.$store.state.game.ProviderTypes
    },
    memberInfo() {
      let m = this.$store.state.member.info
      let vip = m.group
      uiHelper.setCookie(SESSION.VIP, vip, 1)
      this.currentCurrency = uiHelper.getCurrency()

      // if(this.currentLanguage != m.preferredLanguage && !uiHelper.getCookie("changeLanguage")){
      //   uiHelper.removeCookie('language')
      //   uiHelper.setCookie('language', m.preferredLanguage)
      //   this.currentLanguage = m.preferredLanguage
      //   window.location.reload()
      // }
    },
    memberWallet() {
      this.notLoading = true
    },
    changeForgotPasswordResponse() {
      //new forgotpassword flow
      let response = this.$store.state.member.changeForgotPassword
      if (response.complete) {
        try {
          this.$ga.event('Account', `Reset Password`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.updateForgotPasswordCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_UPDATE_FORGOT_PASSWORD}`)
      }
    },
    registerResponseComplete() {
      let response = this.$store.state.member.registerResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Register`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.registerResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_REGISTER_STORE}`)
      }
    },
    loginResponseComplete() {
      let response = this.$store.state.member.loginResponse
      /* Check Path Should Reload */
      if (this.$route.fullPath == '/sportsbook/bti') {
        window.location.reload()
      }
      if (response.complete) {
        try {
          this.$ga.event('Account', `Login`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        if (response.success) {
          this.setGoogleAnalyticUserId()
          this.oneSignal()
        }
        this.loginResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_LOGIN_STORE}`)
        this.$store.dispatch(`${ONE_SIGNAL_PLAYER_IDS_RESET_STORE}`)
      }
    },
    logoutResponseComplete() {
      let response = this.$store.state.member.logoutResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Logout`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.logoutResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_LOGOUT_STORE}`)

        // Shutdown and reboot intercom on logout to clear session
        this.bootIntercom()
      }
    },
    verifyContactResponseComplete() {
      let response = this.$store.state.member.verifyContactResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Verify Contact`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.verifyContactResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_CONTACT_VERIFICATION_STORE}`)
      }
    },
    resetPasswordResponseComplete() {
      let response = this.$store.state.member.resetPasswordResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Reset Password`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.resetPasswordResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_RESET_PASSWORD_STORE}`)
      }
    },
    forgotPasswordResponseComplete() {
      let response = this.$store.state.member.forgotPasswordResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Forgot Password`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.forgotPasswordResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_FORGOT_PASSWORD_STORE}`)
      }
    },
    memberVipTierProgress() {
      if (this.isLoggedIn && this.$store.state.member.vipTierProgress.pairing) {
        if (this.memberVipTierProgress.level_sequence !== undefined) {
          // Update intercom as VIP user
          Intercom('update', {
            is_vip: this.memberVipTierProgress.level_sequence > 3,
            vip_level: this.memberVipTierProgress.level_sequence,
            vip_level_name: this.memberVipTierProgress.name
          })
        }
      }
    }
  },
  created() {
    this.bootIntercom()
    captureAdClick(this.$route.query)
    sendChannelPageview(this.$route.query)
    this.getFacebookPixels()
    if (uiHelper.getCookie('popUpSuccessDialog')) {
      this.popUpSuccessRegister()
    }
    // const { lang } = this.$route.params;
    // const regionLocale = lang;
    //
    // // Set the language and region locale in cookies
    // this.setLanguages(value)
    // this.setRegionLocales(regionLocale)
    this.checkHasSsoToken()
    this.metaScript()
    this.initShowDownloadAPK()
    this.isAndroid()
    this.timeInterval()
    this.getPopupAnnouncement()
    this.pageDialog = this.initializePageDialogProperty()
    if (localStorage.getItem(SESSION.TOKEN)) {
      this.getMemberVipProgress()
      this.validateMemberToken()
    }
    this.setGoogleAnalyticUserId()
    this.getInboxMsg()
    this.$eventHub.$on('open-page-dialog', dialog => {
      this.openPageDialog(dialog)
    })
    this.$eventHub.$on('close-page-dialog', unt => {
      this.closePageDialog()
    })
    this.$eventHub.$on('open-quick-transfer-dialog', gameInfo => {
      this.openQuickTransfer(gameInfo)
    })
    this.$eventHub.$on('close-quick-transfer-dialog', dialog => {
      this.closeQuickTransferDialog()
    })
    this.$eventHub.$on('open-login-dialog', obj => {
      if (obj != null) {
        this.isTransferWalletLoginDialog = obj.isTransfer
      }
      this.openLoginDialog()
    })
    this.$eventHub.$on('close-login-dialog', dialog => {
      this.closeLoginDialog()
    })
    this.getTelegramSsoBotId()
    this.scheduleIosHomeScreenPrompt()
  },
  beforeDestroy() {
    clearInterval(this.$options.validateMemberToken)
    clearTimeout(this.iosShortcutTimer)
  },
  beforeCreate() {
    // Wait for OneSignal to be ready
    const checkOneSignalReady = () => {
      try {
        if (this.$OneSignal && typeof this.$OneSignal.getUserId === 'function') {
          this.$OneSignal.getUserId(result => {
            if (result == null) {
              // Clear localStorage flags to allow prompt to show
              localStorage.removeItem('onesignal-notification-prompt')
              localStorage.removeItem('onesignal-pageview-count')

              // Check notification permission
              this.$OneSignal.getNotificationPermission(permission => {
                if (permission === 'default') {
                  // Wait 12 seconds to let auto-prompt work first, then manually trigger as fallback
                  setTimeout(() => {
                    try {
                      this.$OneSignal.getUserId(userId => {
                        if (!userId) {
                          const promptShown = localStorage.getItem('onesignal-notification-prompt')
                          if (!promptShown) {
                            this.$OneSignal.showSlidedownPrompt().catch(() => {})
                          }
                        }
                      })
                    } catch (e) {
                      // Silently fail - notification will show via auto-prompt
                    }
                  }, 12000)
                }
              })
            } else {
              this.oneSignal()
            }
          })
          if (this.$OneSignal && typeof this.$OneSignal.on === 'function') {
            this.$OneSignal.on('subscriptionChange', result => {
              if (result) {
                this.oneSignal()
              }
            })
          }
        } else {
          setTimeout(checkOneSignalReady, 500)
        }
      } catch (e) {
        setTimeout(checkOneSignalReady, 1000)
      }
    }
    checkOneSignalReady()
  },
  methods: {
    popUpSuccessRegister() {
      const successResponse = {
        code: 0, // Success code
        success: true, // Registration success
        action: 'registerComplete' // Action label for the success message
      }

      // Call the registerResponseCompleteDialog method with the simulated response
      this.registerResponseCompleteDialog(successResponse)
      uiHelper.removeCookie('popUpSuccessDialog', false)
    },
    async initFacebookPixels(pixelData) {
      // Came through an ad channel with a bound pixel: fire only that pixel
      if (await initChannelPixel(this.$route.query)) return
      let noscriptInserted = false

      pixelData.forEach(pixelConfig => {
        const baseDomain = pixelConfig.domain.replace(/^www\./, '')
        const domainRegex = new RegExp(`(^|\\.)?(www\\.)?${baseDomain.replace(/\./g, '\\.')}$`)
        if (domainRegex.test(window.location.hostname)) {
          if (!window.fbq) {
            ;(function(f, b, e, v, n, t, s) {
              if (f.fbq) return
              n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
              }
              if (!f._fbq) f._fbq = n
              n.push = n
              n.loaded = true
              n.version = '2.0'
              n.queue = []
              t = b.createElement(e)
              t.async = true
              t.src = v
              s = b.getElementsByTagName(e)[0]
              s.parentNode.insertBefore(t, s)
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
          }

          fbq('init', pixelConfig.fb_pixel_id)
          fbq('track', 'PageView')
          console.log(`FB Pixel loaded: ${pixelConfig.fb_pixel_id} for ${pixelConfig.domain}`)

          // ✅ Insert <noscript> only once for the first matching pixel
          if (!noscriptInserted) {
            // the domain's first pixel is only a guess — keep a pixel the ad link already set
            if (!uiHelper.getCookie(SESSION.FB_PIXEL_CODE)) uiHelper.setCookie(SESSION.FB_PIXEL_CODE, pixelConfig.fb_pixel_id, 30)
            const noscript = document.createElement('noscript')
            noscript.innerHTML = `<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelConfig.fb_pixel_id}&ev=PageView&noscript=1" />`
            document.body.appendChild(noscript)
            noscriptInserted = true
          }
        }
      })
    },
    bootIntercom() {
      window.Intercom('shutdown') // Ensure Intercom is fully reset before booting
      window.Intercom('boot', window.intercomSettings)
    },
    getFacebookPixels() {
      this.$store.dispatch(GET_FACEBOOK_PIXEL)
    },
    showIntercomLC() {
      Intercom('show')
      return false
    },
    getTelegramSsoBotId() {
      this.$store.dispatch(`${TELEGRAM_CONFIG}`)
    },
    getListItemTo(gameType) {
      let routeName = ''
      switch (gameType.type) {
        case 'sb':
          routeName = ROUTE_NAME.SPORTSBOOK
          break
        case 'rng':
          routeName = ROUTE_NAME.SLOT
          break
        case 'fishing':
          routeName = ROUTE_NAME.FISHING
          break
        case 'special':
          routeName = ROUTE_NAME.SPECIAL
          break
        case 'ld':
          routeName = ROUTE_NAME.CASINO
          break
        case 'table':
          routeName = ROUTE_NAME.TABLE_GAMES
          break
        case 'lottery':
          routeName = ROUTE_NAME.LOTTERY
          break
        case 'crash':
          routeName = ROUTE_NAME.CRASH
          break
        case 'originals':
          routeName = ROUTE_NAME.ORIGINALS
          break
        case 'cricket':
          routeName = ROUTE_NAME.CRICKET
          break
        default:
          routeName = ROUTE_NAME.HOME
          break
      }
      if (this.$route.params.lang) {
        // If it has a value, include it in the route
        return { name: routeName, params: { lang: this.$route.params.lang } }
      } else {
        // If not, just return the route without params
        return { name: routeName }
      }
    },
    // setLanguages(lang) {
    //   // Set the language in cookies
    //   // Replace the code below with your actual implementation
    //   document.cookie = `language=${lang}; path=/;`;
    // },
    //
    // setRegionLocales(regionLocale) {
    //   // Set the region locale in cookies
    //   // Replace the code below with your actual implementation
    //   document.cookie = `regionLocale=${regionLocale}; path=/;`;
    // },
    rotateImage() {
      this.imageRotation = this.imageRotation === 'rotate(180deg)' ? 'rotate(180deg)' : 'rotate(180deg)'
      this.drawer = !this.drawer
    },
    async oneSignal() {
      let data = {
        player_ids: await this.$OneSignal.getUserId(),
        is_subscribe: await this.$OneSignal.getSubscription(),
        permission_status: await this.$OneSignal.getNotificationPermission()
      }
      await this.$store.dispatch(`${ONE_SIGNAL_PLAYER_IDS}`, { data })
    },
    checkHasSsoToken() {
      let s2 = this.$route.query.s2
      if (typeof s2 != 'undefined' && s2 != '' && s2 != null) {
        uiHelper.setCookie(SESSION.UTM_S2, s2, 1)
      }
      if (typeof this.$route.query.sso != 'undefined' && this.$route.query.sso != null && this.$route.query.sso != '') {
        localStorage.setItem(SESSION.TOKEN, this.$route.query.sso)
        this.$router.push({
          name: ROUTE_NAME.FUNDS
        })
      }
    },
    metaScript() {
      uiHelper.setSchema(this.currentLanguage)
    },
    initShowDownloadAPK() {
      this.showDownloadAPK = uiHelper.shouldShowDownload(this.$store.state.siteSettings.hideDownloadBar)
    },
    hideDownloadBar() {
      this.showDownloadAPK = false
    },
    refreshCurrentState() {
      this.$router.push({
        name: ROUTE_NAME.HOME,
        params: {
          lang: this.$route.params.lang
        }
      })
      this.$forceUpdate()
    },
    downloadAPK() {
      uiHelper.downloadAPK()
    },
    isAndroid() {
      try {
        let isAndroid = AndroidFunction.isMobile() ?? false
        uiHelper.setLocalStorage(CACHE_KEY.IS_ANDROID, isAndroid, 60)
      } catch (e) {
        uiHelper.setLocalStorage(CACHE_KEY.IS_ANDROID, false, 60)
      }
    },
    timeInterval() {
      let gmt = moment
        .parseZone()
        .toString()
        .slice(-8)
      gmt = gmt.substring(0, 4) + gmt.substring(5, 6) + ':' + gmt.substring(6, 8)
      setInterval(() => {
        this.time = `(${gmt}) ${moment()
          .utcOffset(0, true)
          .format('HH:mm:ss')}`
      }, 1000)
    },
    async getPopupAnnouncement() {
      let obj = {
        site: uiHelper.getPopup(),
        type: AnnouncementType.ALL,
        page: '',
        itemsPerPage: ''
      }
      await this.$store.dispatch(`${POPUP_LIST}`, {
        obj
      })
    },
    async getLoginPopupAnnouncement() {
      let obj = {
        site: uiHelper.getLoginPopup(),
        type: AnnouncementType.ALL,
        page: '',
        itemsPerPage: ''
      }
      await this.$store.dispatch(`${LOGIN_POPUP_LIST}`, {
        obj
      })
    },
    async prepareLoginPopups() {
      try {
        await this.getLoginPopupAnnouncement()
      } catch (error) {
        // The freespin picker can still open if the announcement request fails.
      }
      const announcements = this.$store.state.announcement.popupLoginAnnouncement
      if (announcements && announcements.length) {
        this.openInstantLoginPopup()
      }
      this.checkPendingFreespins()
    },
    openInstantLoginPopup() {
      let dayClose = uiHelper.getCookie('popupLogin')
      if (dayClose == null) {
        this.freeSpinDialogShow = false
        this.iosShortcutDialogShow = false
        clearTimeout(this.iosShortcutTimer)
        this.instantLoginDialogShow = true
      }
    },
    closeInstantLoginPopup() {
      let dayClose = uiHelper.getCookie('popupLogin')
      if (dayClose == null) {
        dayClose = 'yes'
      }
      uiHelper.setCookie('popupLogin', 'yes', 5)
      this.instantLoginDialogShow = false
      this.$nextTick(() => {
        this.openFreespinDialog()
        this.scheduleIosHomeScreenPrompt()
      })
    },
    openInstantPopup() {
      let dayClose = uiHelper.getCookie('popup')
      if (dayClose == null) {
        this.iosShortcutDialogShow = false
        clearTimeout(this.iosShortcutTimer)
        this.instantDialogShow = true
      }
    },
    closeInstantPopup() {
      let dayClose = uiHelper.getCookie('popup')
      if (dayClose == null) {
        dayClose = 'yes'
      }
      uiHelper.setCookie('popup', 'yes', 0.5)
      this.instantDialogShow = false
      this.$nextTick(() => {
        this.openFreespinDialog()
        this.scheduleIosHomeScreenPrompt()
      })
    },
    scheduleIosHomeScreenPrompt() {
      if (!uiHelper.shouldPromptIosHomeScreen()) {
        return
      }
      clearTimeout(this.iosShortcutTimer)
      this.iosShortcutTimer = setTimeout(() => {
        if (this.iosShortcutDialogShow || this.instantDialogShow || this.instantLoginDialogShow || this.freeSpinDialogShow) {
          return
        }
        if (!uiHelper.shouldPromptIosHomeScreen()) {
          return
        }
        this.iosShortcutDialogShow = true
      }, 2000)
    },
    closeIosShortcutDialog() {
      uiHelper.dismissIosHomeScreenPrompt()
      this.iosShortcutDialogShow = false
    },
    getInboxMsg() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${INBOX_GET_MSG}`)
      }
    },
    dismissFreespinDialog() {
      this.freeSpinDialogShow = false
      if (this.isLoggedIn) {
        this.markFreespinDismissed()
      }
      this.scheduleIosHomeScreenPrompt()
    },
    freespinDismissStorageKey() {
      const memberCode = this.$store.state.member.info.memberCode || localStorage.getItem(SESSION.USERNAME) || ''
      return memberCode ? 'fs_popup_dismissed_' + memberCode : ''
    },
    markFreespinDismissed() {
      const key = this.freespinDismissStorageKey()
      if (key) {
        this.freeSpinDismissStorageKey = key
        localStorage.setItem(key, '1')
      }
      this.freeSpinDismissed = true
    },
    clearFreespinDismissed() {
      const key = this.freeSpinDismissStorageKey || this.freespinDismissStorageKey()
      if (key) {
        localStorage.removeItem(key)
      }
      this.freeSpinDismissStorageKey = ''
      this.freeSpinDismissed = false
    },
    hasFreespinDismissed() {
      const key = this.freespinDismissStorageKey()
      if (!key) {
        return false
      }
      this.freeSpinDismissStorageKey = key
      return localStorage.getItem(key) === '1'
    },
    async checkPendingFreespins() {
      if (this.hasFreespinDismissed()) {
        this.freeSpinDismissed = true
        return
      }
      if (!this.isLoggedIn || this.freeSpinDialogShow || this.freeSpinChecking || this.freeSpinDismissed) {
        return
      }
      this.freeSpinChecking = true
      try {
        const response = await bonusService.getPendingFreespinGames(uiHelper.getPlatform())
        if (!response || !response.success || !response.data) {
          return
        }
        const games = Array.isArray(response.data.games) ? response.data.games : []
        if (!games.length || !this.isLoggedIn) {
          return
        }
        const counts = games.map(game => Number(game.spin_count) || 0)
        const sameCount = counts.every(count => count === counts[0])
        this.freeSpinGames = games
        this.freeSpinCount = sameCount ? counts[0] : Number(response.data.spin_count) || 0
        this.openFreespinDialog()
      } catch (error) {
        // The inbox already tells the player. A failed lookup must not block login.
      } finally {
        this.freeSpinChecking = false
      }
    },
    openFreespinDialog() {
      if (this.hasFreespinDismissed()) {
        this.freeSpinDismissed = true
        return
      }
      if (!this.isLoggedIn || this.freeSpinDismissed || this.freeSpinDialogShow || !this.freeSpinGames.length) {
        return
      }
      if (this.instantLoginDialogShow || this.instantDialogShow) {
        return
      }
      this.iosShortcutDialogShow = false
      clearTimeout(this.iosShortcutTimer)
      this.freeSpinDialogShow = true
    },
    getMemberVipTierProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
      }
    },

    getGrabCoinSetting() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${GRAB_COIN_SETTING}`, {
        filter
      })
    },
    checkShouldHideCoin() {
      if (typeof uiHelper.getCookie(SESSION.HIDE_COIN) != 'undefined' && uiHelper.getCookie(SESSION.HIDE_COIN) == 1) {
        this.showCoin = false
      } else {
        this.showCoin = true
      }
    },
    getWOF() {
      let currency = uiHelper.getCurrency()
      let filter = {
        currency: currency
      }
      this.$store.dispatch(`${WHEEL_MODULE}`, {
        filter
      })
    },
    checkShouldHideAngpao() {
      if (typeof uiHelper.getCookie(SESSION.HIDE_ANG_PAO) != 'undefined' && uiHelper.getCookie(SESSION.HIDE_ANG_PAO) == 1) {
        this.showAngpao = false
      } else {
        this.showAngpao = true
      }
    },
    dontShowMeAgain() {
      this.showAngpao = false
      uiHelper.setCookie(SESSION.HIDE_ANG_PAO, 1, 0.5)
    },
    navigateToAngpao() {
      this.$router.push({
        name: ROUTE_NAME.REWARDS_BY_TYPE,
        params: {
          type: 'angpao'
        }
      })
    },
    setGoogleAnalyticUserId() {
      if (this.memberInfo.memberCode != '') this.$ga.set('userId', this.memberInfo.memberCode)
    },
    openLiveChat() {
      try {
        this.$ga.event('Live Chat', `Open`, `Open Live Chat`)
      } catch (err) {
        console.log(err)
      }
      window.open('/livechat', 'Live Chat', 'width=350,height=600')
    },
    goToTransferPage() {
      this.$router.push({
        name: ROUTE_NAME.TRANSFER
      })
    },
    goToWithdrawalPage() {
      // The standalone withdrawal route is disabled; withdraw lives on the Funds page tab (same as profileSheet)
      this.$router.push({
        name: ROUTE_NAME.FUNDS,
        params: {
          tab: 'withdrawal',
          lang: this.$route.params.lang
        }
      })
    },
    goToDepositPage() {
      // if (uiHelper.getPlatform() == DevicePlatform.MOBILE) {
      //   let routeData = this.$router.resolve({
      //     name: ROUTE_NAME.DEPOSIT
      //   })
      //   window.open(routeData.href)
      // } else {
      if (this.$route.params.lang) {
        this.$router.push({
          name: ROUTE_NAME.FUNDS,
          params: {
            lang: this.$route.params.lang,
            tab: 'deposit'
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.FUNDS,
          params: {
            tab: 'deposit'
          }
        })
      }
      // this.$router.push({
      //   name: ROUTE_NAME.FUNDS
      //   , params:{lang: uiHelper.getRegionLocale()}
      // })
      //}
    },
    goToProfilePage() {
      // this.$router.push({
      //     name: ROUTE_NAME.PERSONAL,
      // })
      this.showProfileSheet = true
    },
    goToInboxPage() {
      this.$router.push({
        name: ROUTE_NAME.INBOX,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    validateMemberToken() {
      if (new Date(parseInt(localStorage.getItem(SESSION.TOKEN_EXPIRY))) - new Date() < 60000) {
        if (new Date() - new Date(parseInt(localStorage.getItem(SESSION.LAST_ACTIVITY_TIME))) > 10800000) {
          const logoutObj = {}
          let sessionTimedOut = true
          this.$store.dispatch(MEMBER_LOGOUT, {
            logoutObj,
            sessionTimedOut
          })
        } else {
          this.$store.dispatch(MEMBER_REFRESH_TOKEN)
        }
      } else {
        let requiredLoading = false
        this.$store.dispatch(MEMBER_CHECK_TOKEN_VALIDITY, {
          requiredLoading
        })
      }
    },
    memberContactVerification(memberCode, otp, type, contact) {
      let verificationObj = {
        memberCode: memberCode,
        otp: otp,
        type: type,
        contact: contact
      }
      this.$store.dispatch(MEMBER_CONTACT_VERIFICATION, {
        verificationObj
      })
    },
    logout() {
      const logoutObj = {
        domain: uiHelper.getHostname(),
        platform: uiHelper.getPlatform()
      }
      let sessionTimedOut = false
      this.$store.dispatch(MEMBER_LOGOUT, {
        logoutObj,
        sessionTimedOut
      })
    },
    maskBalance() {
      this.showBalance = !this.showBalance
    },
    getMemberWallet() {
      const lastDispatchTime = sessionStorage.getItem('lastDispatchTime')

      if (!lastDispatchTime || Date.now() - parseInt(lastDispatchTime) > 15 * 1000) {
        this.notLoading = false
        sessionStorage.setItem('lastDispatchTime', Date.now()) // Update last dispatch time in sessionStorage
        this.$store.dispatch(MEMBER_WALLET)
      }

      this.maskBalance()
    },
    getMemberVipProgress() {
      this.$store.dispatch(MEMBER_GET_VIP_PROGRESS)
    },
    /* DIALOG */
    closeRegisterSuccessDialog() {
      this.registerSuccessDialogShow = false
    },
    closeNewRegisterDialogShow() {
      this.newRegisterDialogShow = false
    },
    closeQuickTransferDialog() {
      this.quickTransferDialogShow = false
      let routeData = this.$router.resolve({
        name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
        params: {
          provider: this.ptGameInfo.provider,
          type: this.ptGameInfo.type,
          lang: this.$route.params.lang
        },
        query: {
          id: this.ptGameInfo.id,
          code: this.ptGameInfo.code,
          demo: 0
        }
      })
      try {
        this.$ga.event('Game', `${0 ? 'Demo' : 'Real'} Play`, `${this.ptGameInfo.provider.toUpperCase()} - Slot - ${this.ptGameInfo.locale.find(x => x.language == 'en').name}`, this.ptGameInfo.id)
      } catch (err) {
        console.log(err)
      }
      uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
    },
    openRegisterDialog() {
      this.registerDialogShow = true
      this.closeWaitRegisterDialog()
      this.closeLoginDialog()
      this.closeForgotPasswordDialog()
      try {
        srtmCommands.push({
          event: 'track.user.registration',
          payload: {
            action: 'start'
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    openRegister() {
      // this.openRegisterDialog()
      this.closeWaitRegisterDialog()
      this.closeLoginDialog()
      this.closeForgotPasswordDialog()
      this.$router.push({ name: ROUTE_NAME.REGISTER })
      // this.$router.push({
      //     name: ROUTE_NAME.REGISTER
      // })
    },
    // openRegisterDialog() {
    //   // this.registerDialogShow = true
    //   this.closeWaitRegisterDialog()
    //   this.closeLoginDialog()
    //   this.closeForgotPasswordDialog()
    //   this.$router.push({name: ROUTE_NAME.REGISTER})
    // },
    closeRegisterDialog(actionFromRegisterDialog = true) {
      this.registerDialogShow = false
      this.$store.dispatch(`${MEMBER_RESET_SMS_VERIFICATION}`)
      // if (this.firstTimeRegister && actionFromRegisterDialog) {
      //   this.openWaitRegisterDialog()
      //   this.firstTimeRegister = false
      // }
    },
    // openLoginDialog() {
    //   this.loginDialogShow = true
    //   this.closeWaitRegisterDialog()
    //   this.closeRegisterDialog(false)
    // },
    closeLoginDialog() {
      if (this.isTransferWalletLoginDialog) {
        this.$router.push({
          name: ROUTE_NAME.SLOT_BY_PROVIDER,
          params: {
            provider: 'all',
            lang: this.regionLocale
          }
        })
      }
      this.loginDialogShow = false
    },
    openForgotPasswordDialog() {
      this.forgotPasswordDialogShow = true
      this.closeLoginDialog()
    },
    closeForgotPasswordDialog() {
      this.forgotPasswordDialogShow = false
    },
    openResetPasswordDialog(memberCode, contact) {
      this.resetPasswordObj.memberCode = memberCode
      this.resetPasswordObj.contact = contact
      this.closeForgotPasswordDialog()
      this.resetPasswordDialogShow = true
    },
    closeResetPasswordDialog() {
      this.resetPasswordObj.memberCode = ''
      this.resetPasswordObj.contact = ''
      this.resetPasswordDialogShow = false
    },
    openLanguageDialog() {
      this.languageDialogShow = true
    },
    closeLanguageDialog() {
      this.languageDialogShow = false
    },
    openLoginDialog() {
      this.loginDialogShow = true
      this.closeForgotPasswordDialog()
      this.closeWaitRegisterDialog()
      this.closeRegisterDialog(false)
    },
    openQuickTransfer(gameInfo) {
      this.ptGameInfo = gameInfo
      this.quickTransferDialogShow = true
      this.transferToProvider = gameInfo.provider == 'pt' ? 'PT' : 'MAIN'
      this.transferMessage = locale.getMessage(`label.ptQuickTransfer`, [this.transferToProvider])
    },
    openProfileSheet() {
      this.showProfileSheet = true
    },
    closeProfileSheet() {
      this.showProfileSheet = false
    },
    openPageDialog(dialog) {
      this.pageDialog = dialog
      this.pageDialogShow = true
    },
    closeTimeOutDialog() {
      localStorage.removeItem(SESSION.TOKEN)
      this.closePageDialog()
      this.refreshCurrentState()
    },
    closePageDialog() {
      this.showProfileSheet = false
      this.pageDialogShow = false
      this.initializePageDialogProperty()
    },
    openWaitRegisterDialog() {
      this.waitRegisterDialogShow = true
    },
    closeWaitRegisterDialog() {
      this.waitRegisterDialogShow = false
    },
    /* RESPONSE COMPLETE DIALOG */
    loginResponseCompleteDialog(response) {
      if (response.code != 0 && !response.success) {
        this.loginErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
      } else {
        this.closeLoginDialog()
        this.currentCurrency = uiHelper.getCurrency()
        this.closeRegisterDialog(false)
      }
    },
    logoutResponseCompleteDialog(response) {
      if (response.isSessionTimedOut) {
        this.$router.push({
          name: ROUTE_NAME.HOME
        })
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.${response.action}`)
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closeTimeOutDialog
        })
        this.openPageDialog(dialog)
      }
    },
    forgotPasswordResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        dialog.message.push(locale.getMessage(`message.forgotPasswordSendText`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: this.closePageDialog
        })
        this.closeForgotPasswordDialog()
      }
      this.openPageDialog(dialog)
    },
    updateForgotPasswordCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.resetPassword`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        let self = this
        dialog.message.push(locale.getMessage(`message.resetPasswordComplete`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: self.closeResetPasswordSuccessDialog
        })
      }
      this.closeResetPasswordDialog()
      this.openPageDialog(dialog)
    },
    resetPasswordResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        let self = this
        dialog.message.push(locale.getMessage(`message.resetPasswordComplete`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: self.closeResetPasswordSuccessDialog
        })
      }
      this.closeResetPasswordDialog()
      this.openPageDialog(dialog)
    },
    closeResetPasswordSuccessDialog() {
      let self = this
      this.closePageDialog()
      setTimeout(function() {
        window.location.reload()
      }, 1)
    },
    registerResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
        this.openPageDialog(dialog)
        this.registerErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
      } else {
        // this.registerSuccessDialogShow = true
        let vm = this
        setTimeout(function() {
          // this.registerSuccessDialogShow = false
          vm.$router.push({
            name: ROUTE_NAME.FUNDS
          })
          vm.newRegisterDialogShow = true
        }, 5000)
      }
    },
    verifyContactResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closePageDialog
        })
      } else {
        dialog.message.push(locale.getMessage(`message.contactVerificationComplete`))
        dialog.button.push({
          title: locale.getMessage(`label.ok`),
          action: this.closePageDialog
        })
      }
      this.closeResetPasswordDialog()
      this.openPageDialog(dialog)
    }
  }
}
</script>

<style lang="scss">
.breakWord-onspace {
  white-space: normal;
}

.vip-badge-mobile {
  .v-badge {
    margin-top: 11px;
  }
}

.v-btn--is-elevated {
  box-shadow: 0px 0px !important;
}

.coin_box_gif {
  position: fixed;
  bottom: 32%;
  right: 10px;
  z-index: 200;
  cursor: pointer;
}

.grab_coin_icon {
  animation: swing 1.2s;
  animation-iteration-count: 3;
}

@keyframes swing {
  20% {
    transform: rotate(15deg);
  }

  40% {
    transform: rotate(-10deg);
  }

  60% {
    transform: rotate(5deg);
  }

  80% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

// .v-badge__badge {
//   bottom: 14px !important;
// }

.language_desktop {
  position: absolute;
  top: 70px;
  right: 3.5%;
}

.icon_middle_nav {
  width: 30px;
  stroke: white;
  fill: white;
}

.icon_btm_nav {
  width: 24px;
  height: 24px;
  margin-top: 8px;
  //stroke: #fff;
  fill: var(--v-text_color-base);

  &.chat {
    stroke: white;
    fill: white;
    width: 23px;
    margin-bottom: -8px;
  }

  &.depo_icon_btm_nav {
    height: 40px;
    width: 42px;
  }
}

.icon_normal {
  width: 25px;
  fill: white;
  color: black;
  stroke: #e4282f;
}

.icon_large {
  width: 35px;
  fill: white;
  color: black;
  margin-top: -5px;
}

.gold-gradient {
  background: transparent linear-gradient(180deg, #ffa15c 0%, #e2d200 100%) 0% 0% no-repeat padding-box;
  font-weight: bold;
}

.btn_img_lc {
  width: 30px;
  padding-bottom: 0;
  padding-left: 5px;
  margin-left: 10px;
}

.gold-color {
  background-color: #b87953 !important;
}

.yellow-color {
  background-color: #fddd04 !important;
}

.v-btn.theme-button.liveChatButton {
  background: #8d1cff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000080;
  opacity: 1;
}

.mobile-member-info-box {
  padding: 5px 15px;
  background: #121734;
  box-shadow: 0px 3px 6px #00000042;
  border-radius: 8px;

  .mobile-member-info-box-text {
    font-size: 15px;
  }

  .mobile-member-info-box-text-icon {
    font-size: 12px;
  }

  .mobile-member-info-box-balance {
    font-size: 15px;
    font-weight: bold;
  }

  .mobile-member-info-box-icon {
    height: auto !important;

    .v-icon {
      font-size: 28px;
    }
  }
}

.ChatButton {
  width: 200px;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  z-index: 1;
  min-height: auto !important;
  position: fixed;
  height: auto;
  top: 30%;
  right: -80px;
  transform: rotate(-90deg);

  span {
    font-size: 24px;
    font-weight: normal;
  }
}

.header-row {
  display: flex;
  flex-direction: column;
  padding-left: 1em;
  padding-right: 1em;
}

button {
  &.round {
    border-radius: 50% !important;
  }

  &.buttonWhite {
    box-shadow: none;
  }

  span {
    letter-spacing: 0;
  }
}

.v-btn.primary-button {
  border-radius: 10px;
  color: black;
  text-transform: capitalize; // border-radius: 25px;
  width: 100%;
  font-size: 16px;
}

.sticky-header {
  position: sticky;
  top: 0;
}

.brand-logo {
  position: absolute;
  left: 3%;
  transform: translateX(-3%);
  z-index: 1;
  top: -1%;
  width: 300px;
  margin-top: 20px;
}

.mobile-brand-logo {
  width: 250px;
}

.img_flag_select {
  width: 23px;
  height: 17px;
  margin-left: -10px;
  margin-right: 4px;
}

.member-menu-divider {
  border-color: white !important;
}

.div_header {
  background-color: #2d3487;
  padding-top: 20px;
}

.splitter_header {
  padding: 0;
  background-color: #3a3eb1;
  margin: 0 auto;
}

.header-icon-button-link {
  height: 40px !important;
  min-width: auto !important;
  width: 40px !important;
  margin-left: 8px;
}

.header-icon-button-more {
  height: 40px !important;
}

.status-bar {
  position: fixed;
  z-index: 5;
  height: 30px;
  width: 100%;
  background-color: var(--v-base-base);
  font-size: 14px;

  .status-bar-wrapper {
    width: 100%;
    max-width: 1240px;
    margin: auto;
  }

  .status-bar-language {
    .v-btn {
      background: rgba(255, 255, 255, 0.3);
      height: auto;
    }

    .v-btn:hover {
      background-color: rgba(13, 84, 62, 1);
    }

    .v-btn__content {
      text-transform: capitalize;
    }
  }

  .status-bar-icon {
    display: flex;
    position: relative;
    //color: #d5d5d5;
    color: var(--v-text_color-darken2);
    padding: 0px 8px;
    cursor: pointer;

    i {
      padding: 0px 4px 0px 0px;
      //color: #d5d5d5;
      color: var(--v-text_color-darken2);
    }

    .v-image {
      margin-right: 4px;
    }
  }

  .status-bar-icon:hover {
    //color: #ffffff;
    color: var(--v-text_color-lighten1);

    i {
      //color: #ffffff;
      color: var(--v-text_color-lighten1);
    }
  }

  .status-bar-icon:not(:last-child)::before {
    content: '';
    position: absolute;
    top: 20%;
    right: 0;
    width: 1px;
    height: 60%;
    border-right: 1px solid var(--v-text-base);
    opacity: 0.8;
  }
}

.download-bar {
  position: fixed;
  z-index: 5;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0px 12px;
  background-color: #f5f5f5;
  line-height: 1;

  .download-bar-button {
    background: linear-gradient(to bottom, #ffab2d, #ff7700);
    color: #fff;
  }
}

.download-bar-height {
  margin-top: 60px;
}

.download-bar-height-body {
  margin-top: 120px;
}

.header-top {
  height: 80px;

  background: transparent linear-gradient(180deg, #0047ff 0%, #5a00b4 100%) 0% 0% no-repeat padding-box;
  //  box-shadow: 0px 2px 6px #00000059;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 5;

  .v-toolbar__content {
    max-width: 1240px;
    width: 100%;
    margin: auto;
    padding: 0px;
  }

  .theme--dark.v-btn.v-btn--icon {
    color: var(--v-text_reverse-base);
  }
}

// NG88 heritage header (mobile + desktop share the brand gradient and slots)
.header-top.ng-header {
  height: auto !important;
  background: var(--ng-gradient-brand);
  box-shadow: 0 2px 6px rgba(18, 23, 52, 0.2);

  .v-toolbar__content {
    max-width: 1440px;
    padding: 0 12px;
  }
}

.ng-header-mobile,
.ng-header-desktop {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 10px;
}

.ng-header-desktop {
  gap: 20px;
  padding: 0 12px;
}

.ng-header-logo {
  flex: none;
  display: flex;
  align-items: center;

  img {
    width: auto;
  }
}

.ng-header-mobile .ng-header-logo {
  flex: 1 1 auto;
  min-width: 0;
}

.ng-header-actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.ng-header-icon-btn {
  flex: none;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ng-header-login {
  min-height: 36px;
  padding: 0 14px;
}

.ng-balance-chip {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 4px 0 12px;
  gap: 8px;
  border-radius: 999px;
  background: var(--ng-navy);

  .ng-balance-amount {
    border: 0;
    background: transparent;
    color: #ffffff;
    font-family: var(--ng-font-bold);
    font-style: italic;
    font-size: 14px;
    white-space: nowrap;
    cursor: pointer;
  }

  .ng-balance-plus {
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 999px;
    background: var(--ng-gradient-cta);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.ng-wallet-box {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 6px 0 14px;
  gap: 12px;
  border-radius: var(--ng-radius-md);
  background: var(--ng-navy);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.26);

  .ng-wallet-text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
    color: #ffffff;
  }

  .ng-wallet-label {
    font-size: 11px;
    color: #c9ccf0;
  }

  .ng-wallet-amount {
    font-family: var(--ng-font-bold);
    font-style: italic;
    font-size: 15px;
    white-space: nowrap;
  }

  .refresh-balance {
    transition: transform 0.5s;
  }

  .refresh-balance:hover {
    transform: rotate(215deg);
  }
}

.ng-account-btn {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 52px;
  padding: 0 6px 0 10px;
  border: 0;
  border-radius: var(--ng-radius-md);
  background: rgba(255, 255, 255, 0.15);
  cursor: pointer;
}

.ng-account-menu .v-list-item__title {
  font-size: 14px;
  color: var(--ng-text);
}

@media (max-width: 380px) {
  .ng-header-mobile .ng-header-logo img {
    height: 22px;
  }

  .ng-balance-chip .ng-balance-amount {
    font-size: 13px;
  }
}

.header-column {
  color: var(--v-text_reverse-base);

  .is-login-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .btn-icon {
    margin: 0 2px;
    cursor: pointer;
  }

  .header-divider {
    width: 1px;
    height: 32px;
    margin: 0 4px;
    background-color: white;
  }

  .refresh-balance {
    transition: transform 0.5s;
  }

  .refresh-balance:hover {
    transform: rotate(215deg);
  }

  .invisible-button {
    height: 1.5rem;
    min-width: 120px;
    padding: 4px 12px;
    cursor: pointer;
    opacity: 1;

    .v-btn__content {
      opacity: 1 !important;
    }

    label {
      cursor: pointer;
    }
  }

  .invisible-button:hover {
    border: 1px solid var(--v-secondary-base);
    border-radius: 8px;
  }
}

.account-actions {
  display: flex;

  a {
    margin-left: 5px;
    margin-right: 5px;
    text-decoration: none;
  }

  .flex-column {
    padding-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 12px;

    img {
      height: 35px;
    }
  }
}

.login-form .v-messages__message {
  font-size: 9px !important;
}
.bottom-navigator-text {
  height: 45%;
  font-size: 13px;
}
.header-bottom {
  min-height: 100px;
  color: #ffffff;
  background: transparent linear-gradient(180deg, #4145c4 0%, #121734 150%) 0% 0% no-repeat padding-box;
  position: sticky;
  top: 0;
  z-index: 15;
}

.side-navigation-drawer {
  $side-nav-p: 0px 20px;

  .list-item-container {
    padding: $side-nav-p;
  }

  .side-nav-logo {
    background: transparent linear-gradient(180deg, #0047ff 0%, #5a00b4 100%) 0% 0% no-repeat padding-box;
    padding: 12px 32px;
    margin: 0px !important;
    border-radius: 0px !important;
    justify-content: space-around;
  }

  .v-list {
    padding: 0px;
  }

  .v-list-item__title {
    color: var(--v-primary-base);
  }

  a {
    margin: 0px !important;

    &.v-list-item,
    &.v-list-item--link {
      border-radius: 0;
    }

    &.v-list-item::before,
    &.v-list-item--link::before {
      border-radius: 0;
    }

    &.v-list-item--active {
      //color: #ffffff !important;
      //background-color: var(--v-secondary-base);
    }
  }

  .mobile_list_menu {
    .v-list-item__icon {
      margin: 12px 0;
    }
  }

  .v-list-item__icon:first-child {
    margin-right: 12px 0;
  }

  .side-menu-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .side-menu-icon {
    width: 36px;
    height: 36px;
  }

  .side-menu-bottom {
    width: 30px;
    height: 30px;
  }

  .v-list-item-bottom {
    padding-left: 7px;
  }

  .vip-progress-bar {
    .v-progress-linear__background {
      background-color: #ebebeb !important;
      border-color: #ebebeb !important;
      opacity: 1 !important;
    }

    .v-progress-linear__determinate {
      border-radius: 10px;
    }

    label {
      color: #acacac;
    }
  }
}

.bottom-navigator {
  position: fixed;
  bottom: 0;
  z-index: 4;
  width: 100%;
  background: transparent linear-gradient(180deg, #0047ff 0%, #5a00b4 100%) 0% 0% no-repeat padding-box;
  font-size: 13px;

  .bottom-navigation-center-button {
    margin-top: -32px;
    width: 75px;
    height: 75px;
    border-radius: 50%;
    background: transparent linear-gradient(180deg, #ffab2d 0%, #ff7700 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 8px #00000080;
    color: #fff;
    text-align: center;
    //box-shadow: 0px 1px 6px rgb(0 0 0 / 42%);
    cursor: pointer;
  }

  .bottom-navigator-before-login {
    height: 60px;
    background: transparent linear-gradient(180deg, #0047ff 0%, #361dd2 47%, #5a00b4 100%) 0% 0% no-repeat padding-box;

    .bottom-navigator-before-login-first {
      color: black;
      background-color: #d8d8d8;
      border: 1px solid #ddd;
    }

    .bottom-navigator-before-login-second {
      color: white;

      font: normal normal 600 16px/25px Poppins !important;

      background: transparent linear-gradient(180deg, #ffab2d 0%, #ff7700 100%) 0% 0% no-repeat padding-box;
    }

    .bottom-navigator-before-login-third {
      color: white;
      font: normal normal 600 16px/25px Poppins !important;
      background: transparent linear-gradient(180deg, #0047ff 0%, #361dd2 47%, #5a00b4 100%) 0% 0% no-repeat padding-box;
    }
  }

  .theme--light.v-btn.v-btn--has-bg {
    background-color: transparent;
  }

  a {
    //height: 50px !important;
    letter-spacing: 1px;
    padding: 0 !important;
    display: block;
    border-color: var(--v-base_3-base);
    text-decoration: none;

    &::before {
      opacity: 0 !important;
    }

    // &.link-active {
    //   border-color: #8C8CDB;
    //   .icon_btm_nav {
    //     fill: #8C8CDB;
    //     stroke: #8C8CDB;
    //     ;
    //   }
    //   .v-icon {
    //     color: #8C8CDB;
    //   }
    //   p {
    //     color: #8C8CDB;
    //   }
    // }
    p {
      margin: -2px 0 0 0;
      text-transform: capitalize;
      color: white;
    }
  }
}

// NG88 heritage bottom nav: same gradient, yellow active state, raised orange Deposit
.bottom-navigator {
  background: transparent linear-gradient(180deg, #0047ff 0%, #5a00b4 100%) 0% 0% no-repeat padding-box !important;
  box-shadow: 0 -2px 8px rgba(18, 23, 52, 0.25);
  padding-bottom: env(safe-area-inset-bottom);

  .bottom-navigator-text {
    font-family: var(--ng-font);
    letter-spacing: 0;
  }

  a.link-active p,
  a.link-active .bottom-navigator-text {
    color: var(--ng-yellow) !important;
    font-family: var(--ng-font-bold);
  }

  .bottom-navigation-center-button {
    width: 64px;
    height: 64px;
    margin-top: -26px;
    border: 3px solid #ffffff;
    box-sizing: border-box;
    padding-left: 0 !important;
    background: var(--ng-gradient-cta);
  }

  .middledeposit {
    font-family: var(--ng-font-bold);
  }

  .bottom-navigator-before-login {
    .bottom-navigator-before-login-first {
      color: var(--ng-navy);
      background-color: #ffffff;
      border: 0;
      border-top: 1px solid var(--ng-line);
    }

    .bottom-navigator-before-login-second {
      color: var(--ng-navy);
      background: var(--ng-gradient-cta);
    }
  }
}

.mobile-header-detail {
  // margin-top: 36px !important;
  background-color: #fff;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 12px;
  min-height: 46px;

  .header-wallet {
    font-size: 14px;
    padding: 15px 35px 15px 15px;
  }

  .header-wallet-icon {
    margin-left: -25px;
  }
}

.mobile-header-rightBtns {
  justify-content: flex-end;
}

@media (max-width: 1499px) {
  .div_header {
    padding-top: 0;
  }

  .language_desktop {
    top: 60px;
    right: 4%;
  }
}

@media (max-width: 1263px) {
  .language_desktop {
    right: 6%;
  }

  .header-icon-button-link {
    height: 35px !important;
    width: 35px !important;
    margin-left: 4px;
  }

  .header-icon-button-more {
    height: 35px !important;
    margin-left: 4px;
    min-width: auto !important;
    width: 30px !important;

    .v-icon {
      height: 15px !important;
      font-size: 28px !important;
    }
  }

  .header-text {
    font-size: 13px !important;
  }
}

@media (max-width: 1024px) {
  .header-text-statis-word {
    display: none;
  }
}

@media (max-width: 599px) {
  .header-top {
    height: 60px;
    // background: var(--v-primary-base) !important;

    .v-toolbar__content {
      padding: 4px 16px;
    }

    .toolbar-icon {
      color: var(--v-text_reverse-base);
    }
  }

  .v-btn.primary-button {
    font-size: 12px;
    width: 100%;
  }

  .language_desktop {
    position: absolute;
    top: 50px;
    right: 13%;
  }

  .liveChatButton {
    display: none;
  }

  .header {
    height: 50px;
    background-image: linear-gradient(to right, var(--v-primary-base), var(--v-primary_3-base));
    padding: 0 15px;

    .mobile-brand-logo {
      width: auto !important;
      height: 25px !important;
      margin-top: 5px;
    }

    .header-mobile-livechat {
      position: absolute;
      top: 0;
      right: 15px;
      height: 100%;

      .v-icon {
        font-size: 25px;
        padding-right: 5px;
      }

      .v-btn__content {
        font-size: 16px;
      }
    }
  }

  .v-btn.v-size--default {
    font-size: 14px;
  }
  .v-btn.v-btn--icon.v-size--default {
    width: 40px !important;
  }
}

@media (max-width: 599px) {
  .header {
    padding: 0 15px;

    .header-mobile-livechat {
      .v-icon {
        font-size: 25px;
      }

      .v-btn__content {
        font-size: 16px;
      }
    }
  }

  .mobile-brand-logo {
    margin-top: -10px;
    margin-left: -10px;
    width: 200px;
  }

  .profile-alert-success {
    font-size: 14px;
  }

  .profile-alert-failed {
    font-size: 14px;
  }

  .bottom-navigator {
    background-color: #ff7700;

    .v-btn.v-btn--has-bg {
      background: transparent;

      .v-btn__content {
        font-size: 12px;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }
  }
}

@media (max-width: 410px) {
  .middledeposit {
    height: 57% !important;
  }
  .bottom-navigator {
    background-color: #ff7700;

    .v-btn.v-btn--has-bg {
      background: transparent;

      .v-btn__content {
        font-size: 10px;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }
  }
  .bottom-navigator-text {
    font-size: 10px;
  }
}
@media (max-width: 340px) {
  .bottom-navigator {
    background-color: #ff7700;

    .v-btn.v-btn--has-bg {
      background: transparent;

      .v-btn__content {
        font-size: 8px;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }
  }
  .bottom-navigator-text {
    font-size: 8px;
  }
}

.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(4, end) 900ms infinite;
  animation: ellipsis steps(4, end) 900ms infinite;
  content: '\2026';
  /* ascii code for the ellipsis character */
  width: 0px;
}

@keyframes ellipsis {
  to {
    width: 20px;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 20px;
  }
}

.box {
  display: flex;
  flex-wrap: wrap;
  text-transform: none;
  //justify-content:flex-start;
  //align-items: stretch;
  width: 310px;
  height: 100%;
  gap: 10px 20px;
  margin: 10px;
}

.box item {
  flex: 1;
  width: calc(33.33%);
  //max-width: 33%;
  margin: 10px;
  padding: 10px;
  width: 100px !important;
  height: 42px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.sidenav {
  width: 80px !important;
  height: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
</style>

<style lang="scss">
// NG88 heritage mobile side menu
.side-navigation-drawer.ng-drawer {
  // Above the floating Rewards / chat buttons (z-index 11) so they don't sit on top of the open menu
  z-index: 13 !important;
  background: #ffffff;
  font-family: var(--ng-font);

  .side-nav-logo {
    min-height: 60px;
    padding: 0 16px !important;
    background: var(--ng-gradient-brand) !important;
  }

  .v-list-item:not(.sidenav) {
    min-height: 52px;
    margin: 2px 8px !important;
    border-radius: 12px !important;

    &::before {
      border-radius: 12px !important;
    }

    &.v-list-item--active {
      background: #f1efff;
    }
  }

  .side-nav-logo.v-list-item {
    margin: 0 !important;
    border-radius: 0 !important;
  }

  .list-item-container {
    align-items: center;
    padding: 0 4px 0 0 !important;
  }

  .side-menu-icon-wrapper {
    width: 40px;
    height: 40px;
    margin: 6px 10px 6px 0 !important;
    border-radius: 12px;
    background: #fff4e0;
  }

  .side-menu-icon {
    width: 26px !important;
    height: 26px !important;
  }

  .side-menu-bottom {
    width: 24px !important;
    height: 24px !important;
  }

  .v-list-item__title {
    padding-left: 0 !important;
    color: var(--ng-text) !important;
    font-family: var(--ng-font-bold);
    font-size: 15px;
  }

  // Keep the label and its "Best" badge on one centred line
  .v-list-item__title .row {
    flex-wrap: nowrap;
    align-items: center !important;

    > .col {
      flex: none;
      margin-top: 0 !important;
    }

    > .text-center {
      width: auto !important;
      margin-left: 8px !important;
      padding: 1px 8px;
      border-radius: 999px !important;
      line-height: 16px;
    }
  }

  .ng-drawer-chevron {
    font-size: 22px !important;
    color: #b9bde0 !important;
  }

  hr {
    margin: 8px 16px;
    border: 0;
    border-top: 1px solid var(--ng-line);
  }

  // Game category grid
  .box {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    width: auto;
    margin: 8px 12px;
    padding: 10px;
    border-radius: 16px;
    background: var(--ng-cloud);
  }

  .box .sidenav.v-list-item {
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    height: 80px !important;
    margin: 0 !important;
    padding: 6px 4px !important;
    border-radius: 12px !important;
    background: #ffffff;
    box-shadow: 0 2px 6px rgba(18, 23, 52, 0.08);
    justify-content: center;

    &::before {
      border-radius: 12px !important;
    }

    .v-list-item__icon {
      margin: 0 auto 4px !important;
    }

    .side-menu-icon-wrapper {
      width: auto;
      height: auto;
      margin: 0 !important;
      background: transparent;
    }

    .side-menu-icon {
      width: 30px !important;
      height: 30px !important;
    }

    .v-list-item__content {
      padding: 0;
    }

    .v-list-item__title {
      font-size: 12px !important;
      white-space: normal;
      line-height: 1.2;
    }

    &.v-list-item--active {
      background: var(--ng-gradient-brand);
      box-shadow: 0 6px 14px rgba(54, 29, 210, 0.3);

      .v-list-item__title {
        color: #ffffff !important;
      }
    }
  }
}
</style>
